/*
* Create a component for three dot menu.
*/

import React, { useState, useEffect, memo } from 'react';
import { WbEventHandlerMixins } from '../utils/common';
import ImgIconComp from './imgcomp';
import GoalDeleteConfirmPopup from './popup/confirm_delete/goal/index';
import GoalServices from '../services/goal.services';
import { withTranslation } from 'react-i18next';

const goalServices = new GoalServices()

const HamburgMenuComp = (props) => {
  const [menus, updateMenus] = useState(props.menu || false);
  const [position, updatePosition] = useState({});
  const [goalMenuItemsId, updategoalMenuItemsId] = useState("");
  const [goalIdToDelete, setGoalIdToDelete] = useState('');
  
  useEffect( () => {
    const source = props.source || false;
    if (source == 'board_top_menu' || props.menuClass == 'metric-popup-menu') {
      updateMenus(props.menu)
    }
  }, [menus]);

  useEffect( () => { updateMenus(props.menu)  }, [props.menu]);

  useEffect(() => {
    const showId = goalMenuItemsId;
    if (document.querySelector(`.teamgoals-row .wspopupmenu-wrapper[data-id="${showId}"]`)) {
      //$(`.teamgoals-row .wspopupmenu-wrapper[data-id="${showId}"]`).show();
      document.querySelector(`.teamgoals-row .wspopupmenu-wrapper[data-id="${showId}"]`).style.display = "inline";
    }
    if (document.querySelector(`.rectbox-hover-row-table .wspopupmenu-wrapper[data-id="${showId}"]`)) {
      //$(`.rectbox-hover-row-table .wspopupmenu-wrapper[data-id="${showId}"]`).show();
      document.querySelector(`.rectbox-hover-row-table .wspopupmenu-wrapper[data-id="${showId}"]`).style.display = "inline";
    }
    if (document.querySelector(`.okr-row  .wspopupmenu-wrapper[data-id="${showId}"]`)) {
     // $(`.okr-row .wspopupmenu-wrapper[data-id="${showId}"]`).show();
      document.querySelector(`.okr-row .wspopupmenu-wrapper[data-id="${showId}"]`).style.display = "inline";
    }
  }, [menus, position])

  const handler = (e, item) => {
    e.preventDefault();
    e.stopPropagation();
    if (typeof item.handler === 'function') {
      item.handler(item.item);
    }
  }

  const handleUserKeyPress = (e, item) => {
    if (e.keyCode === 13) {
      handler(e, item)
    }
  }

  const handlerAjaxMenu = (e, item, parentObj, refSrc) => {
    const remainingHt = $('.workstreamMain, .workstreamMainWs').height() - e.pageY;
    let offset = remainingHt - 400;
    if (offset < 0) {
      let el = document.querySelector('.teamWorkstreamWrapper');
      if(el) {
        if ($(e.target).closest('.okr-row').length > 0) {
          offset = remainingHt - 305;
          //el.querySelector('.workstreamRightCol').style.paddingBottom = Math.abs(offset);
          $('.teamWorkstreamWrapper .workstreamRightCol').css({ 'padding-bottom': Math.abs(offset) });
        }
      } else {
        $('.workstreamRightCol').css({ 'margin-bottom': Math.abs(offset) });
        //document.querySelector('.workstreamRightCol').style.paddingBottom = Math.abs(offset);
      }
    } else {
      $('.workstreamRightCol').css({ 'margin-bottom': 0 });
      // document.querySelector('.workstreamRightCol').style.paddingBottom = 0;
    }
    if (!props.menuAjax) {
      return false;
    }
    e.persist();
    e.preventDefault();
    e.stopPropagation();
    let eventPosition = {
      left: e.target.offsetLeft || 0
    };
    showLoaderWidget($('#content'));
    if (props.type == 'goal') {
      $.ajax({
        url: `${wbConfig.baseUrl}/goal/getGoalMenusJson`,
        type: 'get',
        data: { goalId: item.id },
      })
        .done((response) => {
          if (response.status == 'success') {
            const { goalMenuItems } = response;
            if (goalMenuItems) {
              updateGoalMenus(goalMenuItems, item,{},eventPosition,refSrc);
            }
          }
        })
        .always(() => {
          removeLoaderWidget();
        });
    } else if (typeof item.menu_type !== 'undefined' && item.menu_type == 'ws') {
      $.ajax({
        url: `${wbConfig.baseUrl}/rbr/showWsMenuItems`,
        type: 'get',
        data: { rbr_id: item.rbr_id, ws_id: item.id },
      })
        .done((resp) => {
          // console.log(resp);
          // console.log(item);
          const menu = {};
          menu.items = [];
          item = Object.assign({}, item, { rbrOwner: resp.ws.rbrOwner });
          const { removeFromTray } = resp.ws;
          const { meetingAgenda } = resp.ws;
          const { oneOnOneAgenda } = resp.ws;
          if (removeFromTray) {
            menu.items.push({
              title: 'Remove from tray',
              handler: item.handlers.removeFromTray,
              item,
              pic: 'removefromtray_img',
            });
          }
          if (meetingAgenda) {
            menu.items.push({
              title: 'Meeting Agenda',
              handler: WbEventHandlerMixins.meetingAgenda,
              item,
              pic: 'addtomeet_img',
            });
          }
          if (oneOnOneAgenda) {
            menu.items.push({
              title: '1on1 Agenda',
              handler: WbEventHandlerMixins.oneOnOneAgenda,
              item,
              pic: 'addto1on1_img',
            });
          }
          updateMenus(menu)
          const _dataId = `${item.menu_type}_${item.id}`;
          // $(`.rectbox-hover-row-table .wspopupmenu-wrapper[data-id="${_dataId}"]`).show();
          document.querySelector(`.rectbox-hover-row-table .wspopupmenu-wrapper[data-id="${_dataId}"]`).style.display = "inline";
        })
        .fail((error) => {
          removeLoaderWidget();
        })
        .always(() => {
          removeLoaderWidget();
        });
    } else {
      $.ajax({
        url: `${wbConfig.baseUrl}/rbr/ShowGoalMenuItems`,
        type: 'get',
        data: { goalId: item.id },
      })
        .done((response) => {
          if (response.status == 'success') {
            const { goalMenuItems } = response;
            if (goalMenuItems) {
              updateGoalMenus(goalMenuItems, item, parentObj, eventPosition);
            }
          }
        })
        .always((response) => {
          removeLoaderWidget();
        });
    }
  }

  const updateMetricMenus = (metricMenuItem, metric, {}, clickEventPosition={}, refSrc) => {
    const { t } = props;
    const {canUpdate, canEdit, sendPing, resultDet, meetingAgenda, oneOnOneAgenda, closeOut } = metricMenuItem;
    const menu = {};
    menu.items = [];

    if (canUpdate) {
      menu.items.push({
        title: t('Update'),
        handler: props.metricUpdate,
        item: metric,
        spriteClass: 'icon icon-outline-update-24px',
      });
    }
    if (canEdit) {
      menu.items.push({
        title: t('Edit settings'),
        handler: !metric.goal_id && metric.cascade_goal_id != '' ? props.cascadeEditModal : props.metricEdit,
        item: metric,
        spriteClass: 'icon icon-outline-edit-24px',
      });
    }
    if (sendPing) {
      menu.items.push({
        title: t('Ping for update'),
        handler: props.metricPing,
        item: metric,
        spriteClass: 'icon icon-outline-notifications-24px',
      });
    }
    if (resultDet) {
      menu.items.push({
        title: `${t(Results)} ${t('history')}`,
        handler: metricResultDetail,
        item: metric,
        spriteClass: 'icon icon-outline-publish-24px',
      });
    }
    if (props.goalStatus == 1) {
      if (meetingAgenda) {
        menu.items.push({
          title: t('Add to meeting'),
          handler: props.meetingAgenda,
          item: metric,
          spriteClass: 'icon icon-outline-add_circle_outline-24px',
        });
      }
      if (oneOnOneAgenda) {
        menu.items.push({
          title: t('Add to 1on1'),
          handler: props.oneOnOneAgenda,
          item: metric,
          spriteClass: 'icon icon-outline-add_circle_outline-24px',
        });
      }
    }
    if (closeOut) {
      menu.items.push({
        title: t('Close Out'),
        handler: props.openCloseModel,
        item: metric,
        spriteClass: 'icon icon-outline-publish-24px',
      });
    }

    updateMenus(menu);
    updatePosition(clickEventPosition);
    //updategoalMenuItemsId(goalMenuItems.id)
  }

  const metricResultDetail = (item) => {
		const metricId = item.id;
		return window.open(`${wbConfig.baseUrl}/goal/metricKeyResults?id=${metricId}&ref-src=MY_OKR`);
	}

  const updateGoalMenus = (goalMenuItems = {}, item = {}, parentObj = {}, clickEventPosition = {}, refSrc) => {
    const { t } = props;
    const {
      removeFromTray, edit, deleteGoal, show_ping, closeGoal, copyGoal,
      giveBadge, meetingAgenda, oneOnOneAgenda, reopenOkr, addSelfRbr = {}, addManagerRbr = {},
    } = goalMenuItems;
    let refSrcRow = '';
		if (refSrc == 'PAGE_TYPE_OKR_I_OWN' || refSrc == 'PAGE_TYPE_KR_I_UPDATE' || refSrc == 'PAGE_TYPE_MY_TEAM_OKR' || refSrc == 'PAGE_TYPE_MY_MANAGER_OKR') {
        refSrcRow = `${t('MY_OKR')}`
    } else if (refSrc == 'PAGE_TYPE_TEAM_TAB_OKR' || refSrc == 'PAGE_TYPE_MY_DIRECT_OKR' || refSrc == 'PAGE_TYPE_MY_DIRECT_KR') {
        refSrcRow = `${t('TEAM_OKR')}`;
    } else if(refSrc == 'PAGE_TYPE_JUMP_TO_OKR') {
        refSrcRow = `${t('TEAM_OKR')}_JUMP`;
    }
    if (refSrcRow) {
      item.refSrc = refSrcRow;
    }
    const menu = {};
     
    menu.items = [
    ];
    if (removeFromTray && props.type != 'goal') {
      menu.items.push({
        title: t('Remove from tray'),
        handler: item.handlers.removeFromTray,
        item,
        // pic: 'removefromtray_img',
        spriteClass: 'icon icon-outline-remove_circle_outline-24px',
        id: 'goal_remove_from_tray', // don't change the id which is used in automation tool
      });
    }
    if (edit) {
      menu.items.push({
        title: t('Edit settings'),
        handler: WbEventHandlerMixins.editGoal,
        item,
        width: 24,
        // pic: 'edit_img',
        spriteClass: 'icon icon-outline-edit-24px',
        id: 'goal_edit_popup', // don't change the id which is used in automation tool
      });
    }
    if (props.type == 'goal') {
      if (typeof addSelfRbr.isAdd !== 'undefined' && addSelfRbr.isAdd) {
        menu.items.push({
          title: t('Add to Biz Review'),
          handler: WbEventHandlerMixins.addRbrGoal,
          // pic: 'rbr_add_img',
          spriteClass: 'icon icon-biz_review-24px',
          width: 24,
          item: { myRbr: 1, goalId: addSelfRbr.goalId, userId: addSelfRbr.userId },
        });
      }
    }
    if (reopenOkr) {
      menu.items.push({
        title: `${t('Reopen OKR')}`,
        handler: WbEventHandlerMixins.reopenOkr,
        item,
        // pic: 'closegoal_img',
        spriteClass: 'icon icon-outline-grade-24px',
        width: 24,
        id: 'goal_reopen_popup', // don't change the id which is used in automation tool
      });
    }
    if (closeGoal) {
      menu.items.push({
        title: `${t('Close out OKR')}`,
        handler: WbEventHandlerMixins.closeGoal,
        item,
        // pic: 'closegoal_img',
        spriteClass: 'icon icon-outline-grade-24px',
        width: 24,
        id: 'goal_closed_popup', // don't change the id which is used in automation tool
      });
    }
    if (copyGoal) {
      if (refSrcRow) {
        item.refType = 'OKR_COPY'
      }
      menu.items.push({
        title: `${t('Copy & Reset OKR')}`,
        handler: WbEventHandlerMixins.copyGoal,
        item,
        // pic: 'copy_img',
        spriteClass: 'icon icon-outline-file_copy-24px',
        width: 24,
        id: 'goal_copy_popup', // don't change the id which is used in automation tool
      });
    }
    if (show_ping) {
      menu.items.push({
        title: t('Ping for update'),
        handler: WbEventHandlerMixins.pingGoal,
        item,
        // pic: 'ping_img',
        spriteClass: 'icon icon-outline-notifications-24px',
        width: 24,
        id: 'goal_ping', // don't change the id which is used in automation tool
      });
    }
    menu.items.push({
      title: t('Give Feedback'),
      handler: WbEventHandlerMixins.goalBadge,
      item,
      pic: 'badge_img',
      // spriteClass: 'icon icon-outline-file_copy-24px',
      id: 'goal_badge', // don't change the id which is used in automation tool
      width: 28,
      height: 24
    });
    if (meetingAgenda) {
      menu.items.push({
        title: t('Meeting Agenda'),
        handler: WbEventHandlerMixins.meetingAgenda,
        item,
        // pic: 'addtomeet_img',
        spriteClass: 'icon icon-outline-add_circle_outline-24px',
        width: 24,
        id: 'goal_addmeeting_agenda', // don't change the id which is used in automation tool
      });
    }
    if (oneOnOneAgenda) {
      menu.items.push({
        title: t('Add to 1on1 Agenda'),
        handler: WbEventHandlerMixins.oneOnOneAgenda,
        item,
        // pic: 'addto1on1_img',
        spriteClass: 'icon icon-outline-add_circle_outline-24px',
        width: 24,
        id: 'goal_addto1on1_agenda', // don't change the id which is used in automation tool
      });
    }
    if (deleteGoal) {
      menu.items.push({
        title: `${t('Delete OKR')}`,
        handler: () => setGoalIdToDelete(item.id),
        item,
        // pic: 'delete_img',
        spriteClass: 'icon icon-outline-delete_outline-24px',
        width: 24,
        id: 'goal_delete_popup', // don't change the id which is used in automation tool
      });
    }

    updateMenus(menu);
    updatePosition(clickEventPosition);
    updategoalMenuItemsId(goalMenuItems.id)
  }

  const generateMenuAttributes = (item) => {
    const attr = {};
    if (typeof item.id !== 'undefined' && item.id) {
      attr.id = `dotmenu_${item.id}`;
    }
    return attr;
  }

  const getTitleAttributes = (item) => {
    let attr = {};
    if (typeof item.titleDataAttributes === 'object') {
      attr = Object.assign(attr, item.titleDataAttributes);
    }
    return attr;
  }

  const handleDeleteGoal = async () => {
    const { onRefetchGoals } = props;

    try {
      await goalServices.deleteObjective({ goalId: goalIdToDelete });
      onRefetchGoals();
      setGoalIdToDelete('');
    } catch (e) {
      alert('Oops! something went wrong try again later! ')
    }
  }

  const mainmenu = menus.mainmenu || false;
  const menuAjaxLoad = props.menuAjax || false;
  let classNames = ' clickable ';
  if (menuAjaxLoad) {
    classNames = ' cursorPointer ';
  }
  const submenu = menus.submenu || false;
  const menuClass = props.menuClass || '';
  const extraClass = props.extraRight || '';
  let menuItemStyle = {};
  if(props.style){
    menuItemStyle = {...props.style}
  }
  if(props.fromSidePanel) {
    menuItemStyle.position= 'fixed';
  }
  if (menuAjaxLoad && menus && menus.items.length ) {
    const rbrKeepOpen = ($('.leftmenu-wrapper').attr('data-keepopen') == 'true');
    let menuObj; let
      width = 0;
    let isClickedPositon = false;
    //if (props.type == 'goal' || props.type == 'metric') {
    if (props.type == 'goal') {
      menuObj = $('.my_goals_tab');
      menuItemStyle.display = 'block';
      width = 20;
      isClickedPositon = true;
    } else {
      const { menu_type } = props.item;
      if (menu_type && menu_type == 'ws') {
        menuObj = $('#mywobo-ws-wrapper');
      } else {
        menuObj = $('#mywobo-goals-wrapper');
        menuItemStyle.display = 'block';
        isClickedPositon = true;
      }
      width = rbrKeepOpen ? 275 : 40;
    }
    if (isClickedPositon && typeof position.left !== 'undefined') {
        menuItemStyle.left = position.left - 200;
    }
    else {
      const menuObjPosition = $(menuObj).position();
      menuItemStyle.left = menuObj.width() + menuObjPosition.left + width - 220;
    }
  }
  let dataId = props.item ? props.item.id : '';
  if (menuAjaxLoad) {
    if (typeof props.item.menu_type !== 'undefined') {
      dataId = `${props.item.menu_type}_${dataId}`;
    }
  }
  return (
    <div className={`wbpopumenu ${menuClass}`} id="hamburgMenu">
      {(!submenu)
        ? (
          <div
            tabIndex={0}
            className={`wbpopupmenu-ops ${(mainmenu) ? 'wbpopupmenuMain-ops ' : ''}  alignCenter ${props.disableHamburg ? "" : classNames}`}
            onClick={e => handlerAjaxMenu(e, props.item, props.parentObj, props.refSrc)}
            disabled={props.disableHamburg}
          >
          &nbsp;
          </div>
        )
        : ''
      }
      {/* <div className={`wspopupmenu-wrapper ${extraClass}`} style={menuItemStyle} data-id={dataId} onMouseOver={mouseover}> */}
      <div className={`wspopupmenu-wrapper ${extraClass}`} style={menuItemStyle} data-id={dataId} >
       <ul>
        {menus ? menus.items.map((item, index) => (
          
          <li tabIndex={0} key={!submenu ? index : `sub-${index}`}
              onKeyUp={(e) => handleUserKeyPress(e, item)}
              aria-label = {item.title} 
              onClick={e => handler(e, item)}
          >
            <div
              key={!submenu ? index : `sub-${index}`}
              id={!submenu ? index : `sub-${index}`}
              className={` wspopupmenu-list clickable imageWebkit${item.commonImgClass ? ' commonImgClass' : ' '}`}
              {...generateMenuAttributes(item)}
            >
              {item.pic ? <ImgIconComp class={(item.img_class ? 'pictureClass' : 'wspopmenuImage') + (item.imageclass ? (' aiClick ' + item.imageclass) : ' ')} id={item.pic} width={item.width ? item.width : '20'} height={item.height ? item.height : '20'} /> : ''}
              {item.spriteClass ? <div className={item.spriteClass} /> : ''}
              <div className={item.class ? `wspopupmenulabel ${item.class}` : 'wspopupmenulabel'} {...getTitleAttributes(item)}>{item.title}</div>

              {item.submenu && item.submenu.length
                && (
                <div className="submenu">
                  <HamburgMenuComp fromSidePanel={props.fromSidePanel} menu={{ items: item.submenu, mainmenu: 1, submenu: 1 }} source="board_top_menu" />
                </div>
                )
                }

            </div>
          </li>
        )) : ''}
        </ul>
      </div>
      {goalIdToDelete && (
        <div onClick={e => e.stopPropagation()}>
          <GoalDeleteConfirmPopup
            onClose={() => setGoalIdToDelete('')}
            onConfirm={handleDeleteGoal}
          />
        </div>
      )}
    </div>
  );
}

export default memo(withTranslation()(HamburgMenuComp));
